/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


document.addEventListener("DOMContentLoaded", () => {
  initBrandFilter();
});

function initBrandFilter() {
  // Attach click handler to all nav links
  document.querySelectorAll(".brand-nav-item a").forEach((link) => {
    link.addEventListener("click", (e) => {
      const nav = link.getAttribute("data-nav");

      // Remove active class from all nav items
      document.querySelectorAll(".brand-nav-item").forEach((item) => {
        item.classList.remove("active");
      });

      // Toggle active on the clicked link's parent
      const parent = link.parentElement;
      if (parent) parent.classList.toggle("active");

      // Hide all results
      document.querySelectorAll(".brand-results-row").forEach((row) => {
        row.classList.add("inactive");
      });

      // Show matching rows
      document.querySelectorAll(".brand-results-row").forEach((row) => {
        const term = row.getAttribute("data-term");
        if (nav === term) {
          row.classList.remove("inactive");
        }
      });

      // Only prevent default if data-toggle is "brand"
      if (link.getAttribute("data-toggle") === "brand") {
        e.preventDefault();
      }
    });
  });
}